export function initNavToggle(): void {
  const toggleBtn = document.getElementById("nav-toggle");
  const menu = document.getElementById("nav-menu");

  if (!toggleBtn || !menu) return;

  toggleBtn.addEventListener("click", () => {
    const isExpanded = toggleBtn.getAttribute("aria-expanded") === "true";

    // Conmuta el estado accesible y la visibilidad del menú
    toggleBtn.setAttribute("aria-expanded", String(!isExpanded));
    menu.setAttribute("data-open", String(!isExpanded));
  });

  // Cierra el menú al hacer clic fuera de él
  document.addEventListener("click", (e: Event) => {
    const target = e.target as Node;
    if (!toggleBtn.contains(target) && !menu.contains(target)) {
      toggleBtn.setAttribute("aria-expanded", "false");
      menu.setAttribute("data-open", "false");
    }
  });
}
